function t(){try{var n=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(n){}return(t=function(){return!!n})()}export{t as default};
//# sourceMappingURL=isNativeReflectConstruct.js.map
